<script setup>
import { useRouter } from 'vue-router';
import { useAccount } from 'dashboard/composables/useAccount';

const router = useRouter();
const { accountId } = useAccount();

const goToSettings = () => {
  router.push({
    name: 'settings-integrations-twenty',
    params: { accountId: accountId.value },
  });
};
</script>

<template>
  <div class="flex flex-col items-center gap-3 py-4 px-2 text-center">
    <p class="text-sm text-n-slate-11">
      {{ $t('INTEGRATION_SETTINGS.TWENTY.SETUP_CTA.DESCRIPTION') }}
    </p>
    <button
      class="text-sm font-medium text-woot-500 hover:text-woot-600 transition-colors"
      @click="goToSettings"
    >
      {{ $t('INTEGRATION_SETTINGS.TWENTY.SETUP_CTA.BUTTON') }}
    </button>
  </div>
</template>
